module.exports = __webpack_public_path__ + "static/media/guilherme-alves.887258d7.jpeg";